import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BrandVoice = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16, className }, forwardedRef) => {
    return (
      <svg
        role="img"
        className={className}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 3.5C8.5 3.22386 8.27614 3 8 3C7.72386 3 7.5 3.22386 7.5 3.5V12.5C7.5 12.7761 7.72386 13 8 13C8.27614 13 8.5 12.7761 8.5 12.5V3.5ZM4.5 4.5C4.5 4.22386 4.27614 4 4 4C3.72386 4 3.5 4.22386 3.5 4.5V11.5C3.5 11.7761 3.72386 12 4 12C4.27614 12 4.5 11.7761 4.5 11.5V4.5ZM6.5 5.5C6.5 5.22386 6.27614 5 6 5C5.72386 5 5.5 5.22386 5.5 5.5V10.5C5.5 10.7761 5.72386 11 6 11C6.27614 11 6.5 10.7761 6.5 10.5V5.5ZM2 6C2.27614 6 2.5 6.22386 2.5 6.5V9.5C2.5 9.77614 2.27614 10 2 10C1.72386 10 1.5 9.77614 1.5 9.5V6.5C1.5 6.22386 1.72386 6 2 6ZM14 6C14.2761 6 14.5 6.22386 14.5 6.5V9.5C14.5 9.77614 14.2761 10 14 10C13.7239 10 13.5 9.77614 13.5 9.5V6.5C13.5 6.22386 13.7239 6 14 6ZM10 5C10.2761 5 10.5 5.22386 10.5 5.5V10.5C10.5 10.7761 10.2761 11 10 11C9.72386 11 9.5 10.7761 9.5 10.5V5.5C9.5 5.22386 9.72386 5 10 5ZM12 4C12.2761 4 12.5 4.22386 12.5 4.5V11.5C12.5 11.7761 12.2761 12 12 12C11.7239 12 11.5 11.7761 11.5 11.5V4.5C11.5 4.22386 11.7239 4 12 4Z"
        />
      </svg>
    )
  },
)

export default BrandVoice
